import { Select } from "../index";
import PieChart from "../piechart/Piechart";
import RangeBar from "../range-bar/RangeBar";
import Table from "../table/Table";
import { useCreditReport } from "../../data/live";

const asArray = (value) => (Array.isArray(value) ? value : []);

const FactorImpactingScore = () => {
  const { profile, loading } = useCreditReport();
  const factors = profile?.factors || {};
  const scoreFactors = asArray(factors.scoreFactors);
  const influencingFactors = asArray(factors.influencingFactors).map((item) => ({
    category: item.category || "Not set",
    impactOnScore: item.impactOnScore || item.impact || "Not set",
    whatInfluencesYourScore: item.whatInfluencesYourScore || item.reason || "",
    whatCanYouDo: item.whatCanYouDo || item.action || "",
  }));

  const factorinfluencingCreditScoreHeader = [
    "Category",
    "Impact on score",
    "What influences your score",
    "What can you do",
  ];

  if (loading) {
    return <div className="p-5 text-center text-muted border rounded-3 mt-3">Loading credit factors...</div>;
  }

  if (!profile) {
    return <div className="p-5 text-center text-muted border rounded-3 mt-3">No credit profile available.</div>;
  }

  return (
    <>
      <div className="row ">
        {profile.score != null && (
          <div className="col-12 mt-3">
            <div className="d-flex flex-column p-3 px-4 border rounded-3 gap-3">
              <div className="d-flex justify-content-between align-items-center">
                <span className="fs-5 fw-medium">
                  See how your score stacks up
                </span>
                <Select className="rounded-pill w-auto" defaultValue="Country" />
              </div>

              <div className="d-flex justify-content-center align-items-center mt-4 ">
                <RangeBar
                  dataset={[
                    {
                      label: "You",
                      score: Number(profile.score),
                      labelColor: "#1bbb6b",
                      pointerScore: "",
                    },
                  ]}
                />
              </div>
            </div>
          </div>
        )}

        <div className="col-12 mt-3">
          <div className="d-flex flex-column gap-4 p-3 px-4 border rounded-3">
            <div className="d-flex flex-column gap-1">
              <span className="fs-5 fw-medium">
                How is your credit score calculated?
              </span>
              <span className="fs12px" style={{ color: "#7d7d7d" }}>
                Factor data is shown only when it is present in the backend
                credit profile.
              </span>
            </div>

            {scoreFactors.length ? (
              <div className="d-flex align-items-center justify-content-between ps-5 flex-wrap flex-md-nowrap gap-3 gap-md-0">
                <div className="factor-impacting-pie-chart">
                  <PieChart textOffset={-30} pieData={scoreFactors} />
                </div>

                <div className="d-flex flex-column gap-3">
                  {scoreFactors.map(({ name, color, text }) => (
                    <div
                      key={name}
                      className="d-flex flex-column gap-1"
                      style={{ width: "88%" }}
                    >
                      <span className="fs-6 fw-semibold" style={{ color }}>
                        {name}
                      </span>
                      <span className="fs12px" style={{ color: "#7D7D7D" }}>
                        {text}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <div className="p-5 text-center text-muted">No score factors available.</div>
            )}
          </div>
        </div>

        <div className="col-12 mt-3">
          <div className="d-flex flex-column gap-3 border rounded-3">
            <div className="d-flex flex-column p-3 px-4 border-bottom ">
              <span className="fs-5 fw-medium">
                Top factors influencing your Credit Score
              </span>
              <span className="fs12px" style={{ color: "#7D7D7D" }}>
                These rows come from the backend credit profile.
              </span>
            </div>

            <div className="p-3 px-4">
              {influencingFactors.length ? (
                <Table
                  CreditScoreInfoTable={true}
                  tableBody={influencingFactors}
                  keyNumber1={1}
                  condition1={"col-2"}
                  condition2={""}
                  tableHeaders={factorinfluencingCreditScoreHeader}
                />
              ) : (
                <div className="p-5 text-center text-muted">No influencing factors available.</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FactorImpactingScore;
